<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  [showDateFilters]="true" 
  [showDownloadButton]="true" 
  [showSingleDate]="true"
  [(date)]="date"
  (onDateChange)="onDateChange()" 
  (onDownload)="downloadExcel()"
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar balanço patrimonial...">
</app-toolbar-search>

<p-table #dt 
  [value]="contasBalancoPatrimonial" 
  [paginator]="true" 
  [rows]="50"
  [globalFilterFields]="['codigo', 'descricao', 'nivel', 'saldoAnoAtual', 'naturezaSaldoAnoAtual', 'saldoAnoAnterior', 'naturezaSaldoAnoAnterior']"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="loading"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="codigo" style="width: 12%">
        Código <p-sortIcon field="codigo"></p-sortIcon>
      </th>
      <th pSortableColumn="descricao" style="width: 30%">
        Descrição <p-sortIcon field="descricao"></p-sortIcon>
      </th>
      <th pSortableColumn="nivel" style="width: 8%">
        Nível <p-sortIcon field="nivel"></p-sortIcon>
      </th>
      <th pSortableColumn="saldoAnoAtual" style="width: 15%">
        {{ anoAtual }} <p-sortIcon field="saldoAnoAtual"></p-sortIcon>
      </th>
      <th pSortableColumn="naturezaSaldoAnoAtual" style="width: 8%">
        D/C <p-sortIcon field="naturezaSaldoAnoAtual"></p-sortIcon>
      </th>
      <th pSortableColumn="saldoAnoAnterior" style="width: 15%">
        {{ anoAnterior }} <p-sortIcon field="saldoAnoAnterior"></p-sortIcon>
      </th>
      <th pSortableColumn="naturezaSaldoAnoAnterior" style="width: 8%">
        D/C <p-sortIcon field="naturezaSaldoAnoAnterior"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-conta>
    <tr>
      <td>
        <div class="code-content">
          <i class="pi pi-tag code-icon"></i>
          <span class="code-text" [pTooltip]="conta.codigo" tooltipPosition="top">{{ conta.codigo }}</span>
        </div>
      </td>
      <td>
        <div class="description-content">
          <i class="pi pi-align-left description-icon"></i>
          <span class="description-text" [pTooltip]="conta.descricao" tooltipPosition="top">{{ conta.descricao }}</span>
        </div>
      </td>
      <td>
        <div class="level-content">
          <i class="pi pi-sort-numeric-up level-icon"></i>
          <span class="level-text" [pTooltip]="'Nível: ' + conta.nivel" tooltipPosition="top">{{ conta.nivel }}</span>
        </div>
      </td>
      <td>
        <div class="value-content">
          <i class="pi pi-dollar value-icon"></i>
          <span class="value-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAnoAtual) | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAnoAtual) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
      <td>
        <div class="nature-content" *ngIf="conta.saldoAnoAtual !== 0">
          <i class="pi pi-info-circle nature-icon"></i>
          <span class="nature-text" [pTooltip]="conta.descricaoTipoTransacaoAnoAtual" tooltipPosition="top">{{ conta.descricaoTipoTransacaoAnoAtual }}</span>
        </div>
      </td>
      <td>
        <div class="value-content">
          <i class="pi pi-dollar value-icon"></i>
          <span class="value-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAnoAnterior) | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAnoAnterior) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
      <td>
        <div class="nature-content" *ngIf="conta.saldoAnoAnterior !== 0">
          <i class="pi pi-info-circle nature-icon"></i>
          <span class="nature-text" [pTooltip]="conta.descricaoTipoTransacaoAnoAnterior" tooltipPosition="top">{{ conta.descricaoTipoTransacaoAnoAnterior }}</span>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-chart-pie" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum balanço patrimonial encontrado</h3>
          <p>Não há dados de balanço patrimonial para o período selecionado.</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="p-d-flex p-jc-end" style="margin-top: 1%;">
  <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" (click)="voltar()"></button>
</div>